export const inputHeight = '3.75rem';
export const buttonHeight = inputHeight;
export const cardBorderRadius = '24px';
